// Add/remove-row editor for PreflightSettings.subscriptions - one of the 5
// Hard-Coded Values sections (see HardcodedValuesDialog.js). Each entry is
// {id, platform, date, amount}, consumed by the "Cost Calculation" step (see
// cost_calculation.py). Ports reporting-hub's SubscriptionsTable.tsx.

import React from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { PLATFORM_ORDER, titleCasePlatform, isoToDate, dateToIso } from './calcFormat';

const platformOptions = PLATFORM_ORDER.map((p) => ({ label: titleCasePlatform(p), value: p }));

const newId = () => (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `tmp-${Date.now()}-${Math.random()}`);

const SubscriptionsTable = ({ entries, onChange }) => {
  const updateRow = (idx, patch) => {
    onChange(entries.map((e, i) => (i === idx ? { ...e, ...patch } : e)));
  };
  const removeRow = (idx) => onChange(entries.filter((_, i) => i !== idx));
  const addRow = () => onChange([...entries, { id: newId(), platform: 'FINBEE', date: '', amount: 0 }]);

  return (
    <div>
      <div className="cr-table-frame">
      <table className="cr-data-table cr-form-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Originator</th>
            <th className="cr-right">Amount</th>
            <th style={{ width: '2rem' }} />
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, idx) => (
            <tr key={entry.id}>
              <td>
                <Calendar
                  value={isoToDate(entry.date)}
                  onChange={(e) => updateRow(idx, { date: dateToIso(e.value) })}
                  dateFormat="dd/mm/yy"
                  showIcon
                  inputStyle={{ width: '8.5rem', fontSize: '0.82rem' }}
                />
              </td>
              <td>
                <Dropdown
                  value={entry.platform}
                  options={platformOptions}
                  onChange={(e) => updateRow(idx, { platform: e.value })}
                  style={{ width: '13rem', fontSize: '0.82rem' }}
                />
              </td>
              <td className="cr-right">
                <InputNumber
                  value={entry.amount}
                  onValueChange={(e) => updateRow(idx, { amount: e.value || 0 })}
                  mode="decimal"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  inputStyle={{ width: '8rem', textAlign: 'right', fontSize: '0.82rem' }}
                />
              </td>
              <td className="cr-center">
                <Button
                  icon="pi pi-times"
                  className="p-button-danger p-button-rounded p-button-text"
                  aria-label="Remove subscription"
                  onClick={() => removeRow(idx)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <Button label="+ Add subscription" className="p-button-outlined p-button-sm" style={{ marginTop: '0.75rem' }} onClick={addRow} />
    </div>
  );
};

export default SubscriptionsTable;
